import { comics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function PopularSection() {
  const sortedByViews = [...comics].sort((a, b) => b.views - a.views);

  return (
    <section id="popular" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">
              热门韩漫排行
            </h2>
            <p className="text-sm text-foreground-500">
              读者最喜爱的韩漫作品，口碑与人气双重保证
            </p>
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {sortedByViews.slice(0, 8).map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}